<template lang="html">
  <div style="margin: 15px 5%; justify-content: center">
    <IndividualSubmissionOverlay
      @close="submissionToOpen = ''"
      v-if="submissionToOpen"
      key="individual-submission-overlay"
      :submission_id="submissionToOpen"
    />
    <div>
      <div v-if="usePlaceholder">
        <h1>Keyword Cloud</h1>
        <img
          src="/static/cloud_empty.png"
          alt="No Words"
          style="margin: 30px 0"
        />
      </div>
      <div v-else>
        <table style="width: 100%; margin: 0; padding-left: 30px">
          <tr style="width: 100%">
            <td
              style="
                width: 35%;
                font-size: 12px;
                text-align: left;
                vertical-align: middle;
              "
            >
              <span
                style="margin-bottom: 50px; cursor: pointer; font-size: 15px"
                v-on:click="clickEditKeywords = true"
                v-if="showEditKeywordsButton"
                >Edit Keywords</span
              >
            </td>
            <td style="width: 55%">
              <h1 style="margin-bottom: 30px; text-align: left">
                Keyword Cloud
              </h1>
            </td>
            <td>
              <i class="material-icons" style="font-size: 20px">language</i>
            </td>
            <td>
              <div style="font-size: 15px; float: right; margin-bottom: 3px">
                {{ wordCloudLanguage }}
              </div>
            </td>
          </tr>
        </table>
        <table style="width: 103%">
          <tr>
            <td style="width: 100%">
              <vue-word-cloud
                :style="{
                  width: wordCloudWidth,
                  height: '400px',
                }"
                style="margin: 0 auto"
                :spacing="0.2"
                :font-size-ratio="5"
                :words="wordCloudData"
                :color="
                  ([, , sent]) =>
                    sent === 'blu'
                      ? '#72CCD7'
                      : sent === 'red'
                      ? '#EB2D7C'
                      : '#273248'
                "
                font-family="Helvetica"
                font-weight="Bold"
              >
                <template slot-scope="{ text, weight, word }">
                  <div
                    :title="weight"
                    :style="
                      'cursor: pointer; opacity: ' +
                      (selectedWordData === null
                        ? '1'
                        : selectedWordData.word === text
                        ? '1'
                        : '0.15')
                    "
                    @click="onWordClick(text)"
                  >
                    {{ text }}
                  </div>
                </template>
              </vue-word-cloud>
            </td>
            <td style="width: 1%">
              <pl-button @click.native="show_info = true" class="pl-icon">
                <i class="fas fa-info-circle" />
              </pl-button>
              <pl-dialog
                v-if="show_info"
                @close="show_info = false"
                header="The Idea Cloud analyzes the RoundTable for frequent words across student submissions."
              >
                <p class="italics pl-subheading tc">
                  The bigger the word in the cloud, the more times it was used!
                </p>
                <section
                  class="flex justify-center items-center ma3"
                  v-if="hasTeacherPermissionsInCourse"
                >
                  <p class="mr3 pl-caption">
                    Share this visual and become a
                    <b class="link-to-blog" @click="toBlogPost"
                      >Parlay Trailblazer!</b
                    >
                  </p>
                  <div>
                    <img
                      src="/static/shareOnTW.svg"
                      alt="Share on Twitter"
                      @click="shareOnTW"
                      class="social-icons clickable"
                    />
                    <img
                      src="/static/shareOnFB.svg"
                      alt="Share on Facebook"
                      @click="shareOnFB"
                      class="social-icons clickable"
                    />
                  </div>
                </section>
                <pl-button @click.native="show_info = false" class="pl-primary">
                  OK
                </pl-button>
              </pl-dialog>
            </td>
          </tr>
        </table>
        <!--        <div v-if="prog"> put this as prop vue-word-cloud when ready: :progress.sync="prog"-->
        <!--          It is still loading-->
        <!--        </div>-->
        <div v-if="openDialog">
          <table style="display: block; width: 104%">
            <tr>
              <th style="width: 100%">
                <div
                  style="
                    font-size: 24px;
                    font-weight: bold;
                    text-align: left;
                    margin: 30px 0 18px;
                  "
                >
                  {{ selectedWordData.word }} ({{
                    selectedWordData.sentences.length
                  }})
                </div>
              </th>
              <th style="width: 0"></th>
            </tr>
          </table>
          <div class="sentence-card" v-for="sent in selectedWordData.sentences">
            <div
              :class="[sent.is_hidden ? 'hidden-record' : '']"
              v-if="
                hasTeacherPermissionsInCourse ||
                (!hasTeacherPermissionsInCourse && !sent.is_hidden) ||
                (ownSentence(sent.userId) && sent.is_hidden)
              "
            >
              <table style="display: block; width: 100%">
                <tr>
                  <th style="width: 50%">
                    <div
                      class="profile-pic"
                      style="float: left; margin-left: 10px"
                    >
                      <img
                        :src="getUserAvatar(sent.userId)"
                        style="width: 22px; height: 22px; border-radius: 50%"
                        alt="Profile-Picture"
                      />
                    </div>
                    <div style="float: left">
                      <p style="font-weight: normal; font-size: 12px">
                        {{ getUserName(sent.userId) }}
                      </p>
                    </div>
                  </th>
                  <th style="width: 0"></th>
                </tr>
              </table>
              <div
                v-html="getSentence(sent.sentence)"
                style="
                  text-align: left;
                  padding: 0 15px 10px;
                  overflow-wrap: break-word;
                "
              ></div>
              <div style="text-align: left">
                <a
                  id="submission-link"
                  style="cursor: pointer; color: #7fd3de; padding: 0 15px 10px"
                  @click="redirectToSubmission(sent.userId, sent)"
                  >View in Context</a
                >
              </div>
              <div style="padding: 8px"></div>
            </div>
          </div>
          <div v-if="showHiddenMessage">
            <span> This word is related to 1 or more hidden submissions </span>
          </div>
          <div
            style="
              text-align: center;
              cursor: pointer;
              width: 100%;
              margin-bottom: 10px;
              margin-top: 15px;
            "
            @click="closeList()"
          >
            Close
          </div>
        </div>
      </div>
    </div>
    <roundtableNlpWordCloudEditKeywords
      :keywords="keywordData"
      v-if="clickEditKeywords"
    />
  </div>
</template>

<script>
  /* eslint-disable */
  import VueWordCloud from 'vuewordcloud';
  import PlMenu from 'src/app/components/material/components/plMenu/plMenu';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import IndividualSubmissionOverlay from '../individualSubmissionOverlay';
  import roundtableNlpWordCloudEditKeywords from './roundtableNlpWordCloudEditKeywords';
  import {
    createIdeaCloud,
    createSandboxIdeaCloud,
  } from 'features/onlineRoundtables/services/dataVisualization/createIdeaCloud';
  import URLPath from 'services/apiConfigs';
  import allowSharing from 'features/onlineRoundtables/services/dataVisualization/allowSharing';
  export default {
    data() {
      return {
        keywordData: null,
        wordCloudData: [],
        selectedWordData: null,
        showSentences: false,
        usePlaceholder: false,
        submissionToOpen: '',
        wordCloudWidth: '90%',
        clickEditKeywords: false,
        showEditKeywordsButton: true,
        show_info: false,
        wordCloudLanguage: '',
        // prog: undefined,
        showHiddenMessage: false,
      };
    },
    components: {
      VueWordCloud,
      roundtableNlpWordCloudEditKeywords,
      IndividualSubmissionOverlay,
      PlMenu,
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'getProfile',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getOrderedSubmissions',
      ]),
      openDialog() {
        return this.showSentences;
      },
      sharing_url() {
        const roundtableID = this.$route.params.roundtableID;
        return `${URLPath.apiURL}/api/roundtables/${roundtableID}/idea-cloud-public`;
      },
    },
    methods: {
      setAllowingToTrue() {
        if (this.is_sharing_allowed) {
          // Return empty promise to allow a .then() in all scenarios
          return Promise.resolve(null);
        }
        const rt_id = this.getCurrentRT.id;
        const body = { idea_cloud: true };
        const sharing_settings = Object.assign(
          {},
          this.getCurrentRT.sharing_settings,
          body
        );
        this.$store.dispatch('updateRTDetails', { sharing_settings });
        return allowSharing(rt_id, body);
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
      shareOnFB() {
        // this.setAllowingToTrue().then(() => {
        //   FB.ui(
        //     {
        //       method: 'share',
        //       href: this.formatParam(this.sharing_url),
        //     },
        //     function (response) {}
        //   );
        // });
      },
      shareOnTW() {
        this.setAllowingToTrue().then(() => {
          const rtTitle = this.getCurrentRT.title;
          const url = this.formatParam(this.sharing_url);
          const text = this.formatParam(
            `Check out this Idea Cloud from our class discussion "${rtTitle}" on @parlayideas`
          );
          window.open(
            `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
            '',
            'scrollbars=yes,width=650,height=280'
          );
        });
      },
      toBlogPost() {
        window.open(
          'https://parlayideas.com/revolutionize-discussion-become-a-parlay-trailblazer/'
        );
      },
      redirectToSubmission(userID, sentence) {
        let id = '';
        if (this.getCurrentRT.submissions[0].user) {
          this.getCurrentRT.submissions.forEach((submission) => {
            if (
              submission.user.id === userID ||
              (submission.anonymous_identity_id &&
                submission.anonymous_identity_id === userID)
            ) {
              id = submission.id;
            }
          });
        } else {
          this.getCurrentRT.submissions.forEach((submission) => {
            if (submission.anonymous_identity.id === userID) {
              id = submission.id;
            }
          });
        }

        this.submissionToOpen = id;
        const route = {
          name: 'roundtable.feed',
          params: {
            courseID: this.getCourseDetail.id.toString(),
            roundtableID: this.getCurrentRT.id.toString(),
            sentence: sentence.sentence,
          },
          query: {
            submissionID: id,
          },
        };
        this.$store.dispatch('userEnteredSummaryOverlay', true);
        this.$router.push(route);
      },
      checkIsSubmissionHidden(userID) {
        let hidden = false;
        if (this.getCurrentRT.submissions[0].user) {
          this.getCurrentRT.submissions.forEach((submission) => {
            if (
              submission.user.id === userID ||
              (submission.anonymous_identity_id &&
                submission.anonymous_identity_id === userID)
            ) {
              hidden = submission.is_hidden;
            }
          });
        }
        return hidden;
      },
      onWordClick(word) {
        if (this.selectedWordData && word === this.selectedWordData.word) {
          this.showSentences = false;
          this.selectedWordData = null;
        } else {
          this.selectedWordData = Object();
          this.selectedWordData.word = word;
          this.selectedWordData.sentences = this.keywordData[word].sentences;
          this.selectedWordData.sentences.forEach((sent) => {
            const isHidden = this.checkIsSubmissionHidden(sent.userId);
            sent.is_hidden = isHidden;
          });
          this.selectedWordData.freq = this.selectedWordData.sentences.length;
          this.showSentences = true;
        }
      },
      getSentence(sentence) {
        sentence = sentence.replace(
          new RegExp(this.selectedWordData.word, 'ig'),
          '<span style="background-color: #D8F1F4">' +
            this.selectedWordData.word +
            '</span>'
        );

        return sentence.replace(
          new RegExp(this.selectedWordData.word.toLowerCase(), 'ig'),
          '<span style="background-color: #d8f1f4">' +
            this.selectedWordData.word +
            '</span>'
        );
      },
      closeList() {
        this.showSentences = false;
        this.selectedWordData = null;
      },
      getUserName(userId) {
        return this.getSubmissionValue(userId, 'name');
      },
      getUserAvatar(userId) {
        return this.getSubmissionValue(userId, 'avatar_url');
      },
      getSubmissionValue(userId, parameter) {
        let submissions = this.getCurrentRT.submissions;
        let submission = submissions.find(
          (submission) =>
            submission.user.id === userId ||
            (submission.anonymous_identity_id &&
              submission.anonymous_identity_id === userId)
        );
        if (submission) {
          if (!this.getCurrentRT.enable_annonymous) {
            return submission.user[parameter];
          } else {
            if (
              submission.anonymous_identity &&
              !submission.teacher_submission
            ) {
              return submission.anonymous_identity[parameter];
            }
            return submission.user[parameter];
          }
        }
      },
      resizeUpdateWorldCloudSize() {
        window.addEventListener('resize', () => {
          this.wordCloudHeight = window.innerHeight / 3;
          this.wordCloudWidth = window.innerWidth / 3;
        });
      },
      ownSentence(userID) {
        const submissionID = this.getProfile.my_rt_user_details.submission_id;

        const submission = this.getCurrentRT.submissions.filter(
          (submission) => submission.id === submissionID
        );
        if (
          submission[0].user.id === userID ||
          (submission[0].anonymous_identity_id &&
            submission[0].anonymous_identity_id === userID)
        ) {
          return true;
        } else {
          this.showHiddenMessage = true;
        }
      },
      initializeWordCloud() {
        this.wordCloudData = [];
        this.usePlaceholder = false;

        if (
          this.getCurrentRT &&
          this.getCurrentRT.submissions &&
          this.getCurrentRT.submissions.length
        ) {
          this.$store.dispatch('getRoundtableKeywords').then(() => {
            const submissions_with_content =
              this.getCurrentRT.submissions.filter(
                (s) => s.trimmed_prompt_response
              );

            // If there are currently no keywords on the current roundtable
            // but there are existing submissions that have content, we want to
            // generate the keywords for the word cloud.
            if (
              !this.getCurrentRT.keywords &&
              submissions_with_content.length
            ) {
              this.$store.dispatch('keywordGenerationForOlderRoundtables');
            }

            if (
              this.getCurrentRT.keywords &&
              this.getCurrentRT.keywords.length
            ) {
              this.usePlaceholder = false;
              try {
                this.keywordData = JSON.parse(this.getCurrentRT.keywords);

                const lang = this.keywordData.l;
                if (typeof lang !== 'string') {
                  let max = 0;
                  let maxLang = 'Does not exist';
                  Object.keys(lang).forEach((language) => {
                    if (lang[language] > max) {
                      max = lang[language];
                      maxLang = language;
                    }
                  });
                  this.wordCloudLanguage =
                    maxLang === 'Does not exist' ? 'English' : maxLang;
                } else {
                  this.wordCloudLanguage = this.keywordData.l;
                }

                let keys = Object.keys(this.keywordData);
                const len = keys.length > 80 ? 80 : keys.length;
                for (let i = 0; i < len; i++) {
                  const keyword = keys[i];
                  if (this.keywordData[keyword]['removed'] === 'False') {
                    this.wordCloudData.push([
                      keyword,
                      this.keywordData[keyword]['sentences'].length,
                      this.keywordData[keyword]['overall_sentiment'] ===
                      'positive'
                        ? 'blu'
                        : this.keywordData[keyword]['overall_sentiment'] ===
                          'neutral'
                        ? 'dark'
                        : 'red',
                    ]);
                  }
                }

                if (this.wordCloudData.length === 0) {
                  this.usePlaceholder = true;
                }
              } catch (error) {
                console.error(error);
                this.usePlaceholder = true;
              }
            }
          });
        } else {
          this.usePlaceholder = true;
        }
      },
    },
    mounted() {
      // Facebook Init
      // window.fbAsyncInit = function () {
      //   FB.init({ appId: '1550372328564661', autoLogAppEvents: true, xfbml: true, version: 'v2.12'});
      // };

      // (function (d, s, id) {
      //   let js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');

      if (this.getProfile.role.toLocaleLowerCase() !== 'teacher') {
        this.showEditKeywordsButton = false;
      }

      this.initializeWordCloud();

      this.loading_wordcloud = true;
      if (this.$route.name === 'walkthrough.feed') {
        this.show_cloud_svg = true;
        createSandboxIdeaCloud().then((res) => {
          this.svg_data = res.data;
          this.loading_wordcloud = false;
          this.show_cloud_svg = true;
        });
      } else {
        const roundtableID = this.$route.params.roundtableID;
        createIdeaCloud(roundtableID)
          .then(this.handleIdeaCloudResponse)
          .catch(console.error);
      }
      this.resizeUpdateWorldCloudSize();

      EventBus.$on('closeWordList', () => {
        this.clickEditKeywords = false;
      });

      EventBus.$on('updateWordList', (keywords) => {
        this.keywordData = keywords;
        this.wordCloudData = [];

        let keys = Object.keys(this.keywordData);
        const len = keys.length > 80 ? 80 : keys.length;
        for (let i = 0; i < len; i++) {
          const keyword = keys[i];
          if (this.keywordData[keyword]['removed'] === 'False') {
            this.wordCloudData.push([
              keyword,
              this.keywordData[keyword]['sentences'].length,
              this.keywordData[keyword]['overall_sentiment'] === 'positive'
                ? 'blu'
                : this.keywordData[keyword]['overall_sentiment'] === 'neutral'
                ? 'dark'
                : 'red',
            ]);
          }
        }
        this.clickEditKeywords = false;
      });
    },
  };
</script>

<style scoped>
  .profile-pic {
    margin-top: 10px;
    margin-right: 6px;
  }

  .sentence-card {
    border: 1px grey;
    border-radius: 6px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);

    margin-bottom: 14px;
  }

  .social-icons {
    height: 25px;
    margin: 0 10px;
  }

  .link-to-blog:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .hidden-record {
    background: repeating-linear-gradient(
      135deg,
      white,
      white 20px,
      pl-fog 20px,
      pl-fog 23px
    );
  }
</style>



// WEBPACK FOOTER //
// roundtableNlpWordCloud.vue?24dd1139